module.exports = __webpack_public_path__ + "static/media/services-project-bg-2.dab6c862.svg";